export default {
  apiServerUrl: 'https://stopkomat.devsafi.pl/'
};
